






























































































































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import {
  judgeDuplicateEnterpriseName, getEnterpriseDetail, addEnterprise, updateEnterprise,
} from 'service/api';
import InitLocation from 'src/mixin/initLocation';
import MultipleLevelSelect from '@/MultipleLevelSelect';
import Editor from '@/Editor';
import ContactForm from '@/ContactForm';
import ClickOutside from 'src/directive/clickOutside';
import { TypeItem } from 'src/types/views/common';
import { ElForm } from 'element-ui/types/form.d';
import { PopoverComponent } from 'src/types/components/popover';

type TypeList = {id: string; name: string; children: TypeItem[]}[];

interface ContactItem {
  id: string;
  contacts: string;
  mobileTelephone: string;
  department: string;
  email: string;
  telephone: string;
}

interface ChildContactComponent {
  params: ContactItem;
  visible: boolean;
}

const industry: TypeList = [];

const contacts: ContactItem[] = [];

@Component({
  components: { MultipleLevelSelect, Editor, ContactForm },
  directives: { ClickOutside },
})
export default class EnterpriseInformation extends Mixins(InitLocation) {
  @Ref('form') form!: ContactForm & ChildContactComponent;

  @Ref('enterpriseForm') enterpriseForm!: ElForm;

  userInput = {
    type: 0,
    picture: '',
    name: '',
    url: '',
    province: '',
    city: '',
    downtown: '',
    fulladdress: '',
    industry,
    serviceindustry: '',
    serviceindustryname: '',
    contacts,
    description: '',
    productDescription: '',
  };

  hasGarden = false;

  isAdd = false;

  isDescriptionFocus = false;

  isProductDescriptionFocus = false;

  contactIndex = 0;

  loading = false;

  userInputRules = {
    name: [
      { required: true, message: '请输入企业名称', trigger: 'blur' },
      { validator: this.validateDuplicateName, trigger: 'blur' },
    ],
    url: [{ required: true, message: '请输入企业网址', trigger: 'blur' }],
    downtown: [{ required: true, message: '请选择企业所在地区(区级)', trigger: 'blur' }],
    fulladdress: [{ required: true, message: '请输入企业通信地址', trigger: 'blur' }],
    industry: [{
      required: true, message: '请选择企业所处行业', type: 'array', trigger: 'blur',
    }],
    description: [{ required: true, message: '请输入企业简介', trigger: 'blur' }],
    productDescription: [{ required: true, message: '请输入产品及服务介绍', trigger: 'blur' }],
  };

  baseUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : '/';

  // eslint-disable-next-line class-methods-use-this
  async validateDuplicateName(rule: object, value: number,
    callback: (arg0: Error | undefined) => void) {
    if (value) {
      const res = await judgeDuplicateEnterpriseName({ name: value });
      if ((res as { state: boolean }).state) {
        callback(undefined);
      } else {
        callback(new Error('企业名称重复'));
      }
    }
  }

  handleDowntownBlur(e: Event) {
    this.$emit('el.form.blur', e);
  }

  clickDesc() {
    this.isDescriptionFocus = true;
    this.isProductDescriptionFocus = false;
  }

  clickProDesc() {
    this.isDescriptionFocus = false;
    this.isProductDescriptionFocus = true;
  }

  descriptionBlur() {
    this.isDescriptionFocus = false;
  }

  productDescriptionBlur() {
    this.isProductDescriptionFocus = false;
  }

  addContact() {
    this.isAdd = true;
    this.form.params = {
      contacts: '',
      department: '',
      telephone: '',
      mobileTelephone: '',
      email: '',
      id: '',
    };
    this.form.visible = true;
  }

  edit(data: ContactItem, index: number) {
    this.isAdd = false;
    this.contactIndex = index;
    this.form.params = {
      id: data.id,
      contacts: data.contacts,
      department: data.department,
      telephone: data.telephone,
      mobileTelephone: data.mobileTelephone,
      email: data.email,
    };
    this.form.visible = true;
  }

  delContactItem(index: number) {
    (this.$refs[`del_${index}`] as PopoverComponent[])[0].doClose();
    this.userInput.contacts.splice(index, 1);
    this.$message.success('删除成功');
  }

  get province() {
    return this.userInput.province;
  }

  set province(val) {
    this.userInput.province = val;
  }

  get city() {
    return this.userInput.city;
  }

  set city(val) {
    this.userInput.city = val;
  }

  get downtown() {
    return this.userInput.downtown;
  }

  set downtown(val) {
    this.userInput.downtown = val;
  }

  handleUploadSuccess(res: { state: boolean; Logo: string; message: string }) {
    if (res.state) {
      this.$message.success('logo上传成功');
      this.userInput.picture = res.Logo;
    } else {
      this.$notify.error(res.message);
    }
  }

  handleUploadError(err: { message: string }) {
    this.$message.error(err.message);
  }

  computeServiceIndustry() {
    const industryIds: string[] = [];
    const industryNames: string[] = [];
    this.userInput.industry.forEach((item) => {
      if (item.children && item.children.length === 0) {
        industryIds.push(item.id);
        industryNames.push(item.name);
      } else {
        industryIds.push(`${item.id},${item.children.map(child => child.id).join(',')}`);
        industryNames.push(`${item.name}(${item.children.map(child => child.name).join('，')})`);
      }
    });
    this.userInput.serviceindustry = industryIds.length === 0 ? '' : `/${industryIds.join('/')}/`;
    this.userInput.serviceindustryname = industryNames.length === 0 ? '' : industryNames.join(',');
  }

  computeIndustry(idList: string[], nameList: string[]) {
    const localIndustry: TypeList = [];
    idList.forEach((idItem: string, index: number) => {
      const ids = idItem.split(/[,，]/);
      if (ids.length === 1) {
        localIndustry.push({
          id: idItem,
          name: nameList[index],
          children: [],
        });
      } else {
        const names = nameList[index].replace(')', '')
          .replace('(', '，').split('，');
        localIndustry.push({
          id: ids[0],
          name: names[0],
          children: ids.splice(1).map((childId: string, childIndex: number) => ({
            id: childId,
            name: names[childIndex + 1],
          })),
        });
      }
    });
    this.userInput.industry = localIndustry;
  }

  submit() {
    this.enterpriseForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.userInput.contacts.length === 0) {
          this.$notify.error('请至少保存一位联系人信息');
          return;
        }
        this.loading = true;
        try {
          this.computeServiceIndustry();
          const param = {
            ...this.userInput,
            enterpriseContacts1: JSON.stringify(this.userInput.contacts.map(item => ({
              contacts: item.contacts,
              telePhone: item.telephone,
              mobileTelePhone: item.mobileTelephone,
              department: item.department,
              email: item.email,
            }))),
          };
          const service = param.type === 0 ? addEnterprise : updateEnterprise;
          delete param.industry;
          delete param.contacts;
          const res = await service(param);
          if ((res as { state: boolean }).state) {
            this.$message.success(param.type === 0 ? '升级成功！' : '修改成功！');
            this.getDetail();
          } else {
            this.$notify.error((res as { message: string }).message);
          }
        } finally {
          this.loading = false;
        }
      }
    });
  }

  async getDetail() {
    const res: any = await getEnterpriseDetail();
    if (res.code === 503) {
      this.userInput.type = 0;
    } else {
      this.userInput.type = 1;
      const detail = res.data;
      const { userInput } = this;
      userInput.name = detail.name;
      userInput.picture = detail.picture || '';
      userInput.url = detail.url;
      userInput.province = String(detail.province);
      userInput.city = String(detail.city);
      userInput.downtown = String(detail.downtown);
      userInput.fulladdress = detail.fulladdress;
      userInput.description = detail.description;
      userInput.productDescription = detail.productDescription;
      userInput.contacts = detail.contacts.map((item: any) => ({
        contacts: item.contacts,
        telephone: item.telePhone,
        mobileTelephone: item.mobileTelePhone,
        department: item.department,
        email: item.email,
      }));
      this.computeIndustry(detail.serviceindustryid, detail.serviceindustrynameH);
      this.$store.commit('SET_USER', {
        ...this.$store.state.user,
        enterpriseId: detail.id,
        avatar: detail.picture || '',
      });
    }
    this.initLocation();
  }

  mounted() {
    this.getDetail();
  }
}
